import { View } from '@shared/components/View';
import { Dropdown, DropdownButton, DropdownListItem } from '@shared/components/dropdown';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1Bold } from '@shared/components/typography';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { useMonthOptions } from './hooks/useMonthOptions';

export function MonthOptionsDesktop({
  rruleOptions,
  setRruleOptions,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions'>) {
  const {
    dateSelectOptions,
    nthSelectOptions,
    daySelectOptions,
    handleDayOfMonthSelect,
    handleFullNthSelect,
    isDayOfMonthSelected,
    isNthWeekdaySelected,
    dayOfMonthDisplay,
    nthDayDisplay,
    nthDayWeekdayDisplay,
  } = useMonthOptions({ rruleOptions, setRruleOptions });

  return (
    <View>
      <MBTextBody1Bold>
        {i18n('workflowTemplate.component.dateAndRepeat.onDotDotDot')}
      </MBTextBody1Bold>
      <View
        row
        centerVertically
        paddingTop={1}
        paddingBottom={1}
        style={{
          flexShrink: 1,
          flexGrow: 0,
          width: '100%',
        }}
      >
        <MBTouchableOpacity
          style={{ display: 'flex', marginRight: grid(1.5), flexShrink: 0, flexGrow: 0 }}
          onPress={handleDayOfMonthSelect}
        >
          {isDayOfMonthSelected && (
            <MBIconV2 color={Colors.v2.green} name="radio-button" size={grid(4)} />
          )}

          {!isDayOfMonthSelected && (
            <MBIconV2 color={Colors.v2.green} name="unfilled-circle" size={grid(4)} />
          )}
        </MBTouchableOpacity>
        <Dropdown
          button={({ onClick, isOpen }) => (
            <DropdownButton onClick={onClick} open={isOpen} style={{ flexGrow: 1 }}>
              {dayOfMonthDisplay}
            </DropdownButton>
          )}
          closeOnSelect
          style={{ maxHeight: 'min(calc(100vh - 20px), 300px' }}
        >
          {dateSelectOptions.map(option => (
            <DropdownListItem key={option.title} onPress={option.onPress}>
              {option.title}
            </DropdownListItem>
          ))}
        </Dropdown>
      </View>
      <View
        row
        centerVertically
        paddingTop={1}
        paddingBottom={1}
        style={{
          flexShrink: 1,
          flexGrow: 0,
          width: '100%',
        }}
      >
        <MBTouchableOpacity
          style={{ display: 'flex', marginRight: grid(1.5), flexShrink: 0, flexGrow: 0 }}
          onPress={handleFullNthSelect}
        >
          {isNthWeekdaySelected && (
            <MBIconV2 color={Colors.v2.green} name="radio-button" size={grid(4)} />
          )}

          {!isNthWeekdaySelected && (
            <MBIconV2 color={Colors.v2.green} name="unfilled-circle" size={grid(4)} />
          )}
        </MBTouchableOpacity>
        <Dropdown
          button={({ onClick, isOpen }) => (
            <DropdownButton onClick={onClick} open={isOpen} style={{ marginRight: grid(1) }}>
              {nthDayDisplay}
            </DropdownButton>
          )}
          closeOnSelect
          style={{ maxHeight: 'min(calc(100vh - 20px), 300px' }}
        >
          {nthSelectOptions.map(option => (
            <DropdownListItem key={option.title} onPress={option.onPress}>
              {option.title}
            </DropdownListItem>
          ))}
        </Dropdown>
        <Dropdown
          button={({ onClick, isOpen }) => (
            <DropdownButton onClick={onClick} open={isOpen} style={{ flexGrow: 1 }}>
              {nthDayWeekdayDisplay}
            </DropdownButton>
          )}
          closeOnSelect
          style={{ maxHeight: 'min(calc(100vh - 20px), 300px' }}
        >
          {daySelectOptions.map(option => (
            <DropdownListItem key={option.title} onPress={option.onPress}>
              {option.title}
            </DropdownListItem>
          ))}
        </Dropdown>
      </View>
    </View>
  );
}
